<template>
<div v-if="isVisible">
  <div class="loader custom-loader mini" v-if="brand === 'mini'"></div>
  <div class="loader custom-loader rr" v-else-if="brand === 'rr'"></div>
  <div class="loader custom-loader alphabet" v-else-if="brand === 'alphabet'"></div>
  <div class="loader" v-else-if="brand ==='toyota'">
    <svg class="spinner-icon-svg" width="100%" height="100%" viewBox="-10 -10 120 120">
      <path d="M0 50A50 50 0 1 1 50 100" fill="transparent" stroke-width="10"></path>
    </svg>
  </div>
  <object v-else-if="isDarkmode" id="loader" class="loader" type="image/svg+xml" :data="basePath+'/bmw-loading-white.svg'" alt="loader"/>
  <object v-else id="loader" class="loader" type="image/svg+xml" :data="basePath+'/bmw-loading-dark.svg'"  alt="loader"/>
</div>
</template>

<script>
import oneUtils from "../../../../gcdm-one-library/gcdm-one-utils/src/bootstrap";

export default {
  name: "OneLoader",
  inject:['$c', '$t', 'brandClass', 'basePath'],
  computed: {
    brand() {
      return (
        this.$store.state.configurationParams.brand ||
        oneUtils.properties.DEFAULT_FALLBACK_BRAND
      );
    },
    isDarkmode() {
      const queryParams = oneUtils.utils.getQueryParams();

      if(queryParams) {
        return (queryParams.isDarkmode && queryParams.isDarkmode == "true") || (queryParams.isDarkmode != "false" && window.localStorage.getItem("oneid_darkmode_selected_") == "true");
      }
      else {
        return window.localStorage.getItem("oneid_darkmode_selected_" + queryParams.brand) == "true";
      }
    }
  },
  props: {
    isVisible: {
      type: Boolean,
      default: true,
    }
  }
};
</script>

<style lang="scss"  scoped>
.loader {
  width: 100%;
  height: 100%;
}
</style>
